var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.6666C20.9167 11.6666 21.6667 12.4166 21.6667 13.3333V19.9999C21.6667 20.9166 20.9167 21.6666 20 21.6666C19.0833 21.6666 18.3333 20.9166 18.3333 19.9999V13.3333C18.3333 12.4166 19.0833 11.6666 20 11.6666ZM19.9833 3.33325C10.7833 3.33325 3.33334 10.7999 3.33334 19.9999C3.33334 29.1999 10.7833 36.6666 19.9833 36.6666C29.2 36.6666 36.6667 29.1999 36.6667 19.9999C36.6667 10.7999 29.2 3.33325 19.9833 3.33325ZM20 33.3333C12.6333 33.3333 6.66668 27.3666 6.66668 19.9999C6.66668 12.6333 12.6333 6.66659 20 6.66659C27.3667 6.66659 33.3333 12.6333 33.3333 19.9999C33.3333 27.3666 27.3667 33.3333 20 33.3333ZM21.6667 28.3333H18.3333V24.9999H21.6667V28.3333Z",
    fill: "#CF3939"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOutline);
export default __webpack_public_path__ + "static/media/error_outline.fe63fbbb10c567f10115e23a494c947d.svg";
export { ForwardRef as ReactComponent };